import styles from './CreateButtonConfirmationModal.module.css';
import Modal from '../UI/modal/Modal';
import { Formik, Field, Form } from 'formik';

interface ICreateButtonConfirmationModal {
  visible: boolean;
  closeConfirmationModalCallbackHandler: (flag: boolean) => void;
  onSubmitConfirmationModalCallbackHandler: (summary: string, isTestIncident: boolean) => void;
  initialSummary: string;
  onSummaryChange: (summary: string) => void;
}

const CreateButtonConfirmationModal = ({
  visible,
  initialSummary,
  onSummaryChange,
  closeConfirmationModalCallbackHandler,
  onSubmitConfirmationModalCallbackHandler
}: ICreateButtonConfirmationModal) => {
  const closeModalHandler = () => {
    closeConfirmationModalCallbackHandler(false);
  };

  const onSubmitFormHandler = (summary: string, isTestIncident: boolean) => {
    onSubmitConfirmationModalCallbackHandler(summary, isTestIncident);
  };

  return (
    <Modal onClose={closeModalHandler} visible={visible}>
      <h3>Create Incident</h3>
      <div className={styles.silverLine} />
      <h4>Don't Panic</h4>
      <p>
        After you create an incident, an engineer on call from CS Tech will receive a page. You can
        meet them in the Slack channel{' '}
        <a
          href={import.meta.env.VITE_APP_SLACK_LINK_URL}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.csLink}>
          #cs-live
        </a>{' '}
        or the Zoom call.
      </p>
      <Formik
        key={visible ? 'modal-open' : 'modal-closed'}
        initialValues={{ summary: initialSummary, isTestIncident: false }}
        onSubmit={(values) => {
          onSubmitFormHandler(values.summary, values.isTestIncident);
          closeModalHandler();
        }}>
        {({ values, handleChange }) => {
          return (
            <Form>
              <div style={{ marginBottom: '10px' }}>
                <label htmlFor="summary">Summary:</label>
                <Field
                  as="textarea"
                  id="summary"
                  name="summary"
                  placeholder="Why did you click the button?"
                  rows="4"
                  cols="50"
                  className={styles.summaryField}
                  value={values.summary}
                  onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                    handleChange(e);
                    onSummaryChange(e.target.value);
                  }}
                />
              </div>

              <div style={{ marginBottom: '20px' }}>
                <label className={styles.checkboxLabel}>
                  <Field
                    type="checkbox"
                    id="isTestIncident"
                    name="isTestIncident"
                    style={{ marginRight: '8px' }}
                  />
                  Check this box for test incidents only
                </label>
              </div>

              <button type="submit" className={styles.submitButton}>
                Submit
              </button>

              <button type="button" className={styles.cancelButton} onClick={closeModalHandler}>
                Cancel
              </button>
            </Form>
          );
        }}
      </Formik>
    </Modal>
  );
};

export default CreateButtonConfirmationModal;
